import { actionConstants } from './actionConstants';
import { accountService } from '../services/account.service';
import { NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { history } from '../utils/history';
import noti from './toast';
import {
  changeExpiredPasswordRequest,
  loginRequest,
  post,
  put,
} from './method';

export const accountActions = {
  login,
  logout,
  register,
  getUsers,
  inviteUser,
  getInvitations,
  queryInvitation,
  resetPassword,
  checkPasswordExpired,
  changePassword,
  changeExpiredPassword,
};

function login(params) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.LOGIN_REQUEST });
    return await loginRequest(params)
      .then((resp) => {
        localStorage.setItem('userInfo', JSON.stringify(resp));
        noti.success(`Welcome back`);
      })
      .catch((error) => {
        if (error.response) {
          noti.error(error.response.data.error.message);
          dispatch({
            type: actionConstants.LOGIN_FAILURE,
            data: error.response.data.error.message,
          });
        } else {
          noti.error('Something went wrong');
          dispatch({
            type: actionConstants.LOGIN_FAILURE,
            data: 'This could be a CORS issue or a dropped internet connection.',
          });
        }
        throw error;
      });
  };
}

function register(
  firstName,
  lastName,
  displayName,
  email,
  password,
  invitationId,
) {
  return async (dispatch, getState) => {
    dispatch({ type: actionConstants.START_QUERY });
    return await accountService
      .register(firstName, lastName, displayName, email, password, invitationId)
      .then((resp) => {
        NotificationManager.success(
          `Please login to continue`,
          'Register successfully',
          3000,
        );
        dispatch({
          type: actionConstants.REGISTER_SUCCESS,
        });
        dispatch({ type: actionConstants.END_QUERY });
      })
      .catch((error) => {
        NotificationManager.error(
          error.message || 'Something went wrong',
          'Oops',
          3000,
        );
        dispatch({
          type: actionConstants.REGISTER_FAILURE,
          data: error.message,
        });
        dispatch({ type: actionConstants.END_QUERY });
      });
  };
}

function getUsers(token) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_QUERY });
    return await accountService
      .getUsers(token)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_USERS_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_QUERY });
      })
      .catch((error) => {
        NotificationManager.error(
          error.message || 'Something went wrong',
          'Oops',
          3000,
        );
        dispatch({
          type: actionConstants.GET_USERS_FAILURE,
          data: error.message,
        });
        dispatch({ type: actionConstants.END_QUERY });
      });
  };
}

function inviteUser(
  token,
  firstName,
  lastName,
  email,
  tenantToJoinId,
  roleName,
) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_QUERY });
    return await accountService
      .inviteUser(token, firstName, lastName, email, tenantToJoinId, roleName)
      .then((resp) => {
        NotificationManager.success(
          `Invite ${email} success\n${resp.data} created`,
          'Success',
          3000,
        );
        dispatch({
          type: actionConstants.INVITE_USER_SUCCESS,
        });
        dispatch({ type: actionConstants.END_QUERY });
      })
      .then(() => {
        history.push('/invitations');
      })
      .catch((error) => {
        NotificationManager.error(
          error.message || 'Something went wrong',
          'Oops',
          3000,
        );
        dispatch({
          type: actionConstants.INVITE_USER_FAILURE,
          data: error.message,
        });
        dispatch({ type: actionConstants.END_QUERY });
      });
  };
}

function getInvitations(token) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_QUERY });
    return await accountService
      .getInvitations(token)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_INVITATIONS_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_QUERY });
      })
      .catch((error) => {
        NotificationManager.error(
          error.message || 'Something went wrong',
          'Oops',
          3000,
        );
        dispatch({
          type: actionConstants.GET_INVITATIONS_FAILURE,
          data: error.message,
        });
        dispatch({ type: actionConstants.END_QUERY });
      });
  };
}

function queryInvitation(invitationId) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_QUERY });
    return await accountService
      .queryInvitation(invitationId)
      .then((resp) => {
        dispatch({
          type: actionConstants.QUERY_INVITATION_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_QUERY });
      })
      .catch((error) => {
        NotificationManager.error(
          error.message || 'Something went wrong',
          'Oops',
          3000,
        );
        dispatch({
          type: actionConstants.QUERY_INVITATION_FAILURE,
          data: error.message,
        });
        dispatch({ type: actionConstants.END_QUERY });
      });
  };
}

function resetPassword(token, applicationUserId, password) {
  return (dispatch, getState) => {
    dispatch({ type: actionConstants.START_QUERY });
    accountService
      .resetPassword(token, applicationUserId, password)
      .then((resp) => {
        NotificationManager.success('Password was reset', 'Success', 3000);
        dispatch({
          type: actionConstants.RESET_PASSWORD_SUCCESS,
        });
      })
      .then(() => {
        history.push('/users');
      })

      .catch((error) => {
        NotificationManager.error(
          error.message || 'Something went wrong',
          'Oops',
          3000,
        );
        dispatch({
          type: actionConstants.RESET_PASSWORD_FAILURE,
          data: error.message,
        });
        dispatch({ type: actionConstants.END_QUERY });
      });
  };
}

function checkPasswordExpired() {
  return async (dispatch, getState) => {
    return await post('app/users/password-expired/verify')
      .then((isExpired) => {
        return isExpired;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        throw error.response.data.error.message;
      });
  };
}

function changePassword(_params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    return await post('app/users/password/change', params)
      .then((resp) => {
        noti.success('Password is changed');
        return resp;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.CHANGE_PASSWORD_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function changeExpiredPassword(_params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    return await changeExpiredPasswordRequest(
      `app/users/${_params.username}/password/change`,
      params,
    )
      .then((resp) => {
        noti.success('Password is changed');
        return resp;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.CHANGE_PASSWORD_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function logout() {
  return (dispatch, getState) => {
    accountService.logout().then(() => {
      // dispatch({ type: actionConstants.DESTROY_SESSION });
      localStorage.setItem('isSessionInitialized', false);
      localStorage.removeItem('logo');
      dispatch({
        type: actionConstants.CHECK_DEPARTMENT_LICENSE_ONCE,
        data: false,
      });
      dispatch({
        type: actionConstants.SET_LICENSE_EXPIRATION,
        data: null,
      });
      dispatch({
        type: actionConstants.SHOW_LICENSE_EXPIRATION_NOTIFICATION,
        data: false,
      });
      dispatch({
        type: actionConstants.LOGO_HAS_UPDATED,
        data: true,
      });
      dispatch({ type: actionConstants.LOGOUT_REQUEST });
      return;
    });
  };
}
